<template>
  <div class="page-container expense-table-page">
    <portal to="page-name">Gerenciamento de tabelas</portal>
    <div class="loading loading-lg mt-2" v-if="loading" />
    <div class="card card-page" v-else>
      <div class="card-header">
        <div class="card-title">
          Gerenciamento de tabelas - {{ getTitle }}
        </div>
        <div class="text-dark-gray mt-1">
          Configure preços, regras e outros
        </div>
      </div>
      <div class="card-body">
        <st-tabs ref="expense-table-tabs" @changed="changeTabs">
          <st-tab id="tab-data" name="Dados principais">
            <div class="columns">
              <div class="column col-6 col-md-12 col-sm-12 form-group"
                   :class="{'has-error': $v.form.name.$error}">
                <label class="form-label">Nome da tabela</label>
                <input type="text"
                       class="form-input"
                       v-model="form.name"
                       @blur="$v.form.name.$touch()"
                       placeholder="Nome da tabela de preços"
                >
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group"
                   :class="{'has-error': $v.form.startDate.$error}">
                <label class="form-label">Vigência início</label>
                <div class="input-group">
                  <dx-input-date
                    id="appointment-patient-birth-date"
                    class="form-input text-center"
                    v-model="form.startDate"
                    @blur="$v.form.startDate.$touch()"
                  />
                </div>
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group"
                   :class="{'has-error': $v.form.endDate.$error}">
                <label class="form-label">Vigência término</label>
                <dx-input-date
                  id="end-date"
                  class="form-input text-center"
                  v-model="form.endDate"
                  @blur="$v.form.endDate.$touch()"
                />
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group"
                   :class="{'has-error': $v.form.type.$error}">
                <label class="form-label">Tipo</label>
                <select class="form-select"
                        v-model="form.type"
                        @blur="$v.form.type.$touch()"
                >
                  <option v-for="(text, value) in tableTypes"
                          :value="value"
                          :key="value"
                  >{{ text }}
                  </option>
                </select>
              </div>
              <div class="column form-group" v-if="isCbhpm"
                   :class="{'has-error': $v.form.cbhpm.editionCode.$error}">
                <label class="form-label">Edição</label>
                <select class="form-select"
                        v-model="form.cbhpm.editionCode"
                        @blur="$v.form.cbhpm.editionCode.$touch()">
                  <option value="">[Selecione]</option>
                  <option v-for="(text, value) in cbhpmEditions"
                          :value="value" :key="value">{{ text }}</option>
                </select>
              </div>
              <div class="column col-3 col-md-12 col-sm-12 form-group" v-if="isCbhpm"
                   :class="{'has-error': $v.form.cbhpm.calculationCode.$error}">
                <label class="form-label">Tabela de cálculo</label>
                <select class="form-select"
                        v-model="form.cbhpm.calculationCode"
                        @blur="$v.form.cbhpm.calculationCode.$touch()"
                        @change="setCbhpmValues">
                  <option value="">[Selecione]</option>
                  <option v-for="(item, i) in cbhpmItems"
                          :value="item.code" :key="i">{{ item.name }}</option>
                </select>
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group" v-if="isCbhpm"
                   :class="{'has-error': $v.form.cbhpm.operationalCost.$error}">
                <label class="form-label">Custo Operacional</label>
                <dx-input-number class="form-input"
                                 v-model="form.cbhpm.operationalCost"
                                 @blur="$v.form.cbhpm.operationalCost.$touch()"
                                 :precision="4"
                />
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group" v-if="isCbhpm">
                <label class="form-label">Valor m² do Filme</label>
                <dx-input-number class="form-input"
                                 v-model="form.cbhpm.film"
                                 :precision="4"
                />
              </div>
              <div class="column form-group" v-if="isCbhpm">
                <label class="form-label">Coeficiente Porte</label>
                <div class="input-group">
                  <select class="form-select"
                          v-model="form.cbhpm.factor"
                          style="max-width: 80px">
                    <option value="+">Acrés.</option>
                    <option value="-">Decrés.</option>
                  </select>
                  <dx-input-number class="form-input"
                                   v-model="form.cbhpm.coefficient"
                                   :precision="4"
                  />
                  <button class="btn btn-icon btn-action btn-warning input-group-btn"
                          @click="setCbhpmValues">
                    <fa-icon :icon="['fal', 'sync']" />
                  </button>
                </div>
              </div>
            </div>

            <div class="accordion" v-if="isCbhpm && form.cbhpm.postageItems.length > 0">
              <input type="checkbox"
                     id="accordion-postage"
                     name="accordion-checkbox" hidden>
              <label class="accordion-header"
                     for="accordion-postage">
                <i class="icon icon-arrow-right mr-1" />
                Portes
              </label>
              <div class="accordion-body">
                <div class="accordion-detail">
                  <div class="postage-items">
                    <h6>Portes</h6>
                    <div class="columns">
                      <div class="column col-4 col-md-4 col-sm-12">
                        <div v-for="(item, i) in form.cbhpm.postageItems.slice(0, 14)" :key="i">
                          <div class="input-group">
                            <span class="input-group-addon">{{ item.postage }}</span>
                            <dx-input-number
                              class="form-input"
                              :class="{'is-error': $v.form.cbhpm.postageItems
                              .$each[i].value.$error}"
                              @blur="$v.form.cbhpm.postageItems.$each[i].value.$touch()"
                              v-model="item.value"
                              :precision="2"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="column col-4 col-md-4 col-sm-12">
                        <div v-for="(item, i) in form.cbhpm.postageItems.slice(14, 28)" :key="i">
                          <div class="input-group">
                            <span class="input-group-addon">{{ item.postage }}</span>
                            <dx-input-number
                              class="form-input"
                              :class="{'is-error': $v.form.cbhpm.postageItems
                              .$each[i + 14].value.$error}"
                              @blur="$v.form.cbhpm.postageItems.$each[i + 14].value.$touch()"
                              v-model="item.value"
                              :precision="2"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="column col-4 col-md-4 col-sm-12">
                        <div v-for="(item, i) in form.cbhpm.postageItems.slice(28, 42)" :key="i">
                          <div class="input-group">
                            <span class="input-group-addon">{{ item.postage }}</span>
                            <dx-input-number
                              class="form-input"
                              :class="{'is-error': $v.form.cbhpm.postageItems
                              .$each[i + 28].value.$error}"
                              @blur="$v.form.cbhpm.postageItems.$each[i + 28].value.$touch()"
                              v-model="item.value"
                              :precision="2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="divider" />
            </div>

            <div class="stenci-group">
              <div class="empty mt-2" v-if="form.reducerRules.length === 0">
                <div class="empty-icon">
                  <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
                </div>
                <p class="empty-title h6">Regras de redução por múltiplos procedimentos</p>
                <p class="empty-subtitle">
                  Configure a redução aplicada pelo convênio quando há mais de
                  um procedimento na mesma guia
                </p>
                <div class="empty-action">
                  <button class="btn btn-secondary" @click="openReducerRule">
                    Adicionar regra
                  </button>
                </div>
              </div>
              <template v-else>
                <div class="stenci-title">
                  Regras de redução por múltiplos procedimentos (RMP)
                </div>
                <small>
                  Configure a redução aplicada pelo convênio quando há mais de
                  um procedimento na mesma guia
                </small>

                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th>Nível</th>
                    <th>Descrição</th>
                    <th>Base de cálculo</th>
                    <th class="text-center" style="width: 60px">1º</th>
                    <th class="text-center" style="width: 60px">2º</th>
                    <th class="text-center" style="width: 60px">3º</th>
                    <th class="text-center" style="width: 60px">4º</th>
                    <th class="text-right" style="width: 60px">
                      <button
                        class="btn btn-icon btn-action btn-primary btn-sm"
                        @click="openReducerRule"
                      >
                        <fa-icon :icon="['fal', 'plus']" />
                      </button>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, i) in form.reducerRules" :key="i">
                    <td>
                      <span
                        class="text-secondary text-bold hover-link"
                        @click="editReducerRule(item, i)"
                      >
                        {{ getLevelName(item.level) }}
                      </span>
                    </td>
                    <td>{{ item.description }}</td>
                    <td>
                      <span class="chip bg-secondary">
                        {{ getCalculationBaseName(item.calculationBase) }}
                      </span>
                    </td>
                    <td class="text-right">
                      <span class="chip bg-success">{{ item.reducers.first }}%</span>
                    </td>
                    <td class="text-right">
                      <span class="chip bg-warning">{{ item.reducers.second }}%</span>
                    </td>
                    <td class="text-right">
                      <span class="chip bg-warning">{{ item.reducers.third }}%</span>
                    </td>
                    <td class="text-right">
                      <span class="chip bg-warning">{{ item.reducers.others }}%</span>
                    </td>
                    <td class="text-right">
                      <button
                        class="btn btn-icon btn-action btn-error btn-sm"
                        @click="removeReducerRule(i)"
                      >
                        <fa-icon :icon="['fal', 'times']" />
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </template>
            </div>

            <div class="divider" />

            <div class="stenci-group" v-if="isBrasindice || isSimpro">
              <div class="text-bold text-info mb-2">
                A atualização automática de preços via
                {{ isBrasindice ? 'Brasíndice' : 'Simpro' }}
                está em desenvolvimento.
              </div>
              <div>
                Você pode adicionar os produtos e realizar a precificação manual
                até a liberação do recurso.
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Observações</label>
              <textarea class="form-input" rows="2"
                        v-model="form.notes"></textarea>
            </div>
          </st-tab>
          <st-tab id="tab-expenses" name="Serviços, taxas e outras despesas">
            <expense-table
              v-if="form.id"
              origin="table"
              :is-cbhpm="savedType === 'cbhpm'"
              :table-id="form.id"
            />
          </st-tab>
        </st-tabs>
      </div>
      <div class="card-footer">
        <button class="btn btn-primary btn-icon btn-icon-left mr-1"
                :class="{loading: saving}"
                :disabled="saving"
                @click="save"
                v-if="!hideSaveButton">
          <fa-icon :icon="['fal', 'save']" />Salvar
        </button>
        <button class="btn" @click="$router.back()">
          Voltar
        </button>
      </div>
    </div>

    <dx-modal id="modal-"
              title="Gerenciar RMP"
              v-model="reducerRule.show">
      <div class="columns">
        <div class="column col-4 col-md-6 col-sm-12 form-group"
             :class="{'has-error': $v.reducerRule.form.level.$error}">
          <label class="form-label">Nível</label>
          <select
            class="form-select"
            v-model="reducerRule.form.level"
            @change="changeLevel"
            @blur="$v.reducerRule.form.level.$touch()"
          >
            <option value="group">Grupo</option>
            <option value="class">Classe</option>
            <option value="code">Código exato</option>
          </select>
        </div>
        <div
          v-if="reducerRule.form.level === 'group'"
          class="column col-8 col-md-6 col-sm-12 form-group"
          :class="{'has-error': $v.reducerRule.form.prefixCode.$error}"
        >
          <label class="form-label">Selecione o grupo</label>
          <select
            class="form-select"
            v-model="reducerRule.form.prefixCode"
            @change="changePrefixCode"
            @blur="$v.reducerRule.form.prefixCode.$touch()"
          >
            <option :value="null">Selecione</option>
            <option v-for="(item, i) in cbhpmGroups" :value="item.code" :key="i">
              {{ item.code }} - {{ item.name }}
            </option>
          </select>
          <div class="form-input-hint" v-if="$v.reducerRule.form.prefixCode.$error">
            Campo obrigatório
          </div>
        </div>
        <div
          v-else
          class="column col-3 col-md-6 col-sm-12 form-group"
          :class="{'has-error': $v.reducerRule.form.prefixCode.$error}"
        >
          <label class="form-label">
            {{ isReducerByCode ? 'Código exato' : 'Classe' }}
          </label>
          <input
            :key="`prefixCode-${isReducerByCode}`"
            type="text"
            class="form-input"
            v-model="reducerRule.form.prefixCode"
            :placeholder="isReducerByCode ? '00.00.00.00' : '00.00'"
            v-mask="isReducerByCode ? '00.00.00.00' : '00.00'"
            @change="findTUSS"
            @blur="$v.reducerRule.form.prefixCode.$touch()"
          />
          <template v-if="$v.reducerRule.form.prefixCode.$error">
            <div class="form-input-hint">Campo obrigatório</div>
          </template>
        </div>
        <div
          v-if="reducerRule.form.level !== 'group'"
          class="column col-12 form-group mb-1"
          :class="{'has-error': $v.reducerRule.form.description.$error}"
        >
          <label class="form-label">Descrição</label>
          <input
            type="text"
            class="form-input"
            v-model="reducerRule.form.description"
            placeholder="Descrição para referência..."
            @blur="$v.reducerRule.form.description.$touch()"
          />
          <template v-if="$v.reducerRule.form.description.$error">
            <div class="form-input-hint">Campo obrigatório</div>
          </template>
        </div>
      </div>
      <div class="divider" />
      <div class="columns">
        <div class="column col-6 col-md-6 col-sm-12 form-group"
             :class="{'has-error': $v.reducerRule.form.calculationBase.$error}">
          <label class="form-label">Base de cálculo</label>
          <select class="form-select" v-model="reducerRule.form.calculationBase"
                  @blur="$v.reducerRule.form.calculationBase.$touch()">
            <option value="total">Valor total</option>
            <option value="pm">Honorário</option>
            <option value="uco">Custo operacional</option>
          </select>
        </div>
        <div class="column form-group">
          <label class="form-label text-center">1º</label>
          <dx-input-number
            class="form-input text-center"
            v-model="reducerRule.form.reducers.first"
            disabled="true"
          />
        </div>
        <div class="column form-group">
          <label class="form-label text-center">2º</label>
          <dx-input-number
            class="form-input text-center"
            :class="{'is-error': $v.reducerRule.form.reducers.second.$error}"
            v-model="reducerRule.form.reducers.second"
            @blur="$v.reducerRule.form.reducers.second.$touch()"
            maxlength="2"
            placeholder="%"
          />
        </div>
        <div class="column form-group">
          <label class="form-label text-center">3º</label>
          <dx-input-number
            class="form-input text-center"
            :class="{'is-error': $v.reducerRule.form.reducers.third.$error}"
            v-model="reducerRule.form.reducers.third"
            @blur="$v.reducerRule.form.reducers.third.$touch()"
            maxlength="2"
            placeholder="%"
          />
        </div>
        <div class="column form-group">
          <label class="form-label text-center">4º+</label>
          <dx-input-number
            class="form-input text-center"
            :class="{'is-error': $v.reducerRule.form.reducers.others.$error}"
            v-model="reducerRule.form.reducers.others"
            @blur="$v.reducerRule.form.reducers.others.$touch()"
            maxlength="2"
            placeholder="%"
          />
        </div>
      </div>
      <template v-slot:footer>
        <button class="btn btn-primary mr-1" @click="saveReducerRule">OK</button>
        <button class="btn" @click="reducerRule.show = false">Sair</button>
      </template>
    </dx-modal>
  </div>
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import minLength from 'vuelidate/lib/validators/minLength';
import maxLength from 'vuelidate/lib/validators/maxLength';
import { cbhpmEditions } from 'src/data/cbhpm-editions';
import { types as tableTypes } from 'src/data/table-types';
import moment from 'moment';
import { mergeFrom } from '@/helpers/object';
import cbhpmGroups, { getCBHPMGroupName } from '@/data/cbhpm-groups';
import ExpenseTable from './ExpenseTable.vue';
import formMixin from '../../../mixins/form';

import {
  date,
  minDate,
} from '../../../data/validators';

export default {
  components: { ExpenseTable },
  mixins: [formMixin],
  data() {
    return {
      isNew: false,
      savedType: '',
      loading: false,
      saving: false,
      hideSaveButton: false,
      cbhpmEditions,
      cbhpmItems: [],
      cbhpmGroups,
      tableTypes,
      getCBHPMGroupName,
      form: this.blankForm(),
      reducerRule: {
        idx: null,
        show: false,
        form: this.blankReducerRuleForm(),
      },
    };
  },
  validations() {
    const { level } = this.reducerRule.form;
    const prefixCodeLen = level === 'code' ? 11 : 5;

    const rules = {
      form: {
        name: { required },
        type: { required },
        startDate: { required, date },
        endDate: { required, date },
        cbhpm: {
          calculationCode: {},
          editionCode: {},
          operationalCost: {},
          postageItems: {},
        },
      },
      reducerRule: {
        form: {
          level: { required },
          description: { required },
          prefixCode: {
            required,
            minLength: level === 'group' ? 2 : minLength(prefixCodeLen),
            maxLength: level === 'group' ? 2 : maxLength(prefixCodeLen),
          },
          calculationBase: { required },
          reducers: {
            first: { required, minValue: minValue(100), maxValue: maxValue(100) },
            second: { required, minValue: minValue(1), maxValue: maxValue(100) },
            third: { required, minValue: minValue(1), maxValue: maxValue(100) },
            others: { required, minValue: minValue(1), maxValue: maxValue(100) },
          },
        },
      },
    };

    if (this.form.startDate) {
      rules.form.endDate = { required, date, minDate: minDate(this.form.startDate) };
    }

    if (this.isCbhpm) {
      rules.form.cbhpm.calculationCode = { required };
      rules.form.cbhpm.editionCode = { required };
      rules.form.cbhpm.operationalCost = { required };
      rules.form.cbhpm.postageItems = {
        $each: {
          value: { required, minValue: minValue(0.0001) },
        },
      };
    }

    return rules;
  },
  async mounted() {
    this.isNew = /create$/.test(this.$route.path);
    await this.init();
  },
  computed: {
    isCbhpm() {
      return this.form.type === 'cbhpm';
    },
    isBrasindice() {
      return this.form.type === 'brasindice';
    },
    isSimpro() {
      return this.form.type === 'simpro';
    },
    isReducerByCode() {
      return this.reducerRule.form.level === 'code';
    },
    getTitle() {
      if (!this.form.id) {
        return 'Novo Registro';
      }
      return this.form.name;
    },
  },
  methods: {
    async init() {
      this.loadCbhpmCalculations();

      if (!this.isNew) {
        this.form.id = this.$route.params.id;
        await this.load();
      }
    },
    load() {
      this.loading = true;

      return this.$http
        .get(`/expense-tables/${this.form.id}`)
        .then(({ data }) => {
          if (data.type === 'cbhpm') {
            data.cbhpm.editionCode = data.cbhpm.edition.code;
            data.cbhpm.calculationCode = data.cbhpm.calculation.code;
            delete data.cbhpm.edition;
            delete data.cbhpm.calculation;
          }

          this.form = mergeFrom(this.blankForm(), data);
          this.savedType = data.type;
        })
        .catch((e) => {
          if (e.response && e.response.status === 404) {
            this.$toast.error('Tabela de preços não encontrada nesta unidade!');
            this.$router.replace('/clinical/expense-tables');
            return;
          }
          this.$toast.error('Erro ao carregar tabela de preços!');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadCbhpmCalculations() {
      const params = {
        limit: 0,
      };

      return this.$http.get('/cbhpm-calculations', { params })
        .then(({ data }) => {
          this.cbhpmItems = data.items;
        })
        .catch(() => {});
    },
    save() {
      this.$v.form.$touch();

      if (this.$v.form.$error) {
        this.$toast.error('Existe uma ou mais inconsistências nos dados principais!');
        this.$refs['expense-table-tabs'].selectTab('tab-data');
        return;
      }

      const data = this.clone(this.form);

      if (this.isCbhpm) {
        const calculation = this.cbhpmItems
          .find(({ code }) => code === data.cbhpm.calculationCode);

        if (!calculation) {
          this.$toast.error('Tabela de cálculo não encontrada. Recarregue a página e selecione novamente.');
          return;
        }

        data.cbhpm.edition = {
          code: data.cbhpm.editionCode,
          name: this.cbhpmEditions[data.cbhpm.editionCode],
        };

        data.cbhpm.calculation = {
          code: calculation.code,
          name: calculation.name,
        };

        delete data.cbhpm.editionCode;
        delete data.cbhpm.calculationCode;
      }

      this.saving = true;

      const request = this.isNew
        ? this.$http.post('/expense-tables', data)
        : this.$http.put(`/expense-tables/${this.form.id}`, data);

      // eslint-disable-next-line consistent-return
      return request
        .then(({ data: result }) => {
          if (this.isNew) {
            this.$router.replace(`/clinical/expense-tables/${result.id}/edit`);
            this.isNew = false;
            this.form.id = result.id;
          }
          this.savedType = this.form.type;
          this.$toast.show('Registro salvo!');
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao salvar a tabela de preços!');
        })
        .finally(() => {
          this.saving = false;
        });
    },
    setCbhpmValues() {
      if (!this.form.cbhpm.calculationCode) {
        return;
      }

      this.form.cbhpm.postageItems = [];

      const found = this.cbhpmItems
        .find(({ code }) => code === this.form.cbhpm.calculationCode);

      if (found.operationalCost) {
        this.form.cbhpm.operationalCost = found.operationalCost;
      }

      if (found.film) {
        this.form.cbhpm.film = found.film;
      }

      this.form.cbhpm.postageItems = this.clone(found.postageItems, true);

      if (this.form.cbhpm.coefficient > 0) {
        let percent = this.form.cbhpm.coefficient || 0;

        if (this.form.cbhpm.factor === '-') {
          percent *= -1;
        }

        this.form.cbhpm.postageItems.forEach((item) => {
          item.value += (item.value * (percent / 100));
          return item;
        });
      }
    },
    findTUSS() {
      const code = this.onlyNumbers(this.reducerRule.form.prefixCode);

      if (code.length === 8) {
        this.$http.get(`/tuss/${code}`)
          .then(({ data }) => {
            this.reducerRule.form.description = `${data.code} - ${data.name}`;
          })
          .catch();
      }
    },
    changeLevel() {
      this.reducerRule.form.prefixCode = null;
      this.reducerRule.form.description = null;
      this.$v.reducerRule.form.$reset();
    },
    changePrefixCode() {
      if (!this.reducerRule.form.prefixCode) {
        this.reducerRule.form.prefixCode = null;
        this.reducerRule.form.description = null;
        return;
      }

      const foundCBHPM = this.cbhpmGroups
        .find(({ code }) => code === this.reducerRule.form.prefixCode);

      this.reducerRule.form.prefixCode = foundCBHPM.code;
      this.reducerRule.form.description = `${foundCBHPM.code} - ${foundCBHPM.name}`;
    },
    openReducerRule() {
      this.reducerRule.idx = null;
      this.reducerRule.form = this.blankReducerRuleForm();
      this.$v.reducerRule.form.$reset();
      this.reducerRule.show = true;
    },
    editReducerRule(item, i) {
      this.reducerRule.idx = i;
      this.reducerRule.form = mergeFrom(this.blankReducerRuleForm(), item);
      this.reducerRule.show = true;
    },
    saveReducerRule() {
      this.$v.reducerRule.$touch();
      if (this.$v.reducerRule.$error) return;

      const payload = this.clone(this.reducerRule.form);

      if (this.reducerRule.idx !== null) {
        this.form.reducerRules[this.reducerRule.idx] = payload;
      } else {
        this.form.reducerRules.push(payload);
      }

      this.reducerRule.show = false;
    },
    removeReducerRule(i) {
      this.form.reducerRules.splice(i, 1);
    },
    changeTabs({ tab }) {
      this.hideSaveButton = tab.hash === 'tab-expenses';
    },
    getLevelName(level) {
      if (level === 'group') return 'Grupo';
      if (level === 'class') return 'Classe';
      return 'Código fixo';
    },
    getCalculationBaseName(calculationBase) {
      if (calculationBase === 'pm') return 'Honorário';
      if (calculationBase === 'uco') return 'Custo operacional';
      return 'Valor total';
    },
    blankForm() {
      return {
        id: '',
        name: '',
        type: 'fixed_table',
        reducerRules: [],
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().add(1, 'year').format('YYYY-MM-DD'),
        notes: '',
        cbhpm: {
          editionCode: '',
          calculationCode: '',
          operationalCost: '',
          film: '',
          factor: '+',
          coefficient: '',
          postageItems: [],
        },
      };
    },
    blankReducerRuleForm() {
      return {
        level: 'group',
        prefixCode: null,
        calculationBase: 'total',
        description: null,
        reducers: {
          first: 100,
          second: 70,
          third: 50,
          others: 50,
        },
      };
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
.expense-table-page {
  .divider {
    margin: $layout-spacing-lg 0;
  }
  .empty {
    padding: $layout-spacing-xl;
  }
}
</style>
